
import Employees from '../views/Employees.vue'
import EmployeeView from '../views/employees/EmployeeView'
import EmployeesAccess from '../views/employees/Access.vue'
import EmployeesWorkgroup from '../views/employees/Workgroup.vue'
import EmployeesTimecards from '../views/employees/Timecards.vue'
import EmployeesAccessCreate from '../views/employees/AccessCreate.vue'
import EmployeesWorked from '../views/employees/Totalhours.vue'
import EmployeesTask from '../views/employees/Task.vue'
import EmployeesTaskDetail from '../views/employees/TaskDetail.vue'

const employees = [
  { path: '/employees/list', name: 'employees_list', component: Employees },
  { path: '/employees/list/:target', name: 'employees_create', component: EmployeeView },
  { path: '/employees/access', name: 'employees_access', component: EmployeesAccess },
  { path: '/employees/workgroup', name: 'employees_workgroup', component: EmployeesWorkgroup },
  { path: '/employees/access/:target', name: 'employees_access_create', component: EmployeesAccessCreate },
  { path: '/employees/timecards', name: 'employees_timecards', component: EmployeesTimecards },
  { path: '/employees/worked', name: 'employees_works', component: EmployeesWorked },
  { path: '/employees/task', name: 'employees_task', component: EmployeesTask },
  { path: '/employees/task/:target', name: 'employees_task_detail', component: EmployeesTaskDetail },
]

export default {
  employees
}



// function lazyLoad(view) {
//   return () => import(`@/views/employees/${view}.vue`)
// }
// const employees = [
//   { path: '/employees/list', name: 'employees_list', component: Employees },
//   { path: '/employees/list/:target', name: 'employees_create', component: lazyLoad('EmployeeView') },
//   { path: '/employees/access', name: 'employees_access', component: lazyLoad('Access') },
//   { path: '/employees/workgroup', name: 'employees_workgroup', component: lazyLoad('Workgroup') },
//   { path: '/employees/access/:target', name: 'employees_access_create', component: lazyLoad('AccessCreate') },
//   { path: '/employees/timecards', name: 'employees_timecards', component: lazyLoad('Timecards') },
//   { path: '/employees/worked', name: 'employees_works', component: lazyLoad('Totalhours') },
//   { path: '/employees/task', name: 'employees_task', component: lazyLoad('Task') },
//   { path: '/employees/task/:target', name: 'employees_task_detail', component: lazyLoad('TaskDetail') },
// ]